export default {
  //(Please Do Not Remove The comma(,) after every variable)

  //Change The Website Template
  name: "Bartoloni Bryan",

  //Contact Email
  contactEmail: "b.bartoloni.dev@gmail.com",

  // Landing Page Name
  landingPageName: "Bartoloni Bryan",

  // Landing Page Paragraph
  landingPagePara:
    "Mobile 📱, Front-end 🖥️ and Game 🎮 developer.\n I'm always looking for interesting and innovative project.",

  // Landing Page Image (replace - root/public/assets/photo.jpg)
  landingPageImage: "assets/photo.png",

  // Change Projects Here
  projects: [
    {
      id: 1, //DO NOT CHANGE THIS (Please)😅
      title: "Seety 📱", //Project Title - Add Your Project Title Here
      // Image Size Should be (300X300 px)
      imageSrc: "assets/seety.png",
      //Project URL - Add Your Project Url Here
      url: "https://seety.co/fr/"
    },
    {
      id: 2, //DO NOT CHANGE THIS (Please)😅
      title: "Oxygis 📱",
      imageSrc: "assets/oxygis.png",
      url: "http://www.oxygis.eu/"
    },
    {
      id: 3, //DO NOT CHANGE THIS (Please)😅
      title: "TheCrewCommunication 🖥️",
      imageSrc: "assets/TCC.png",
      url: "https://www.thecrewcommunication.com/"
    },
    {
      id: 4, //DO NOT CHANGE THIS (Please)😅
      title: "Myskillcamp 🖥️",
      imageSrc: "assets/MSC.png",
      url: "https://myskillcamp.com/"
    },
    {
      id: 5, //DO NOT CHANGE THIS (Please)😅
      title: "Appfundum 📱🎮",
      imageSrc: "assets/AF.png",
      url: "https://play.google.com/store/apps/details?id=com.appfundumV1.app"
    },
    {
      id: 6, //DO NOT CHANGE THIS (Please)😅
      title: "Soloth games 🖥️",
      imageSrc: "assets/SG.png",
      url: "http://soloth-games.com/"
    },
    {
      id: 7, //DO NOT CHANGE THIS (Please)😅
      title: "Deloitte UK 🖥️",
      imageSrc: "assets/deloitte.png",
      url: "https://www2.deloitte.com/"
    },
    {
      id: 8, //DO NOT CHANGE THIS (Please)😅
      title: "On-hertz 🖥️",
      imageSrc: "assets/on-hertz.png",
      url: "https://www.on-hertz.com/"
    },
    {
      id: 9, //DO NOT CHANGE THIS (Please)😅
      title: "INTO IMAGE 🖥️🎮",
      imageSrc: "assets/into-image.png",
      url: "https://www.intoimage.be/icono-un-jeu-interactif/"
    }
    // Paste more projects here from the template

    /*
                    If You Want To Add More Project just Copy and Paste This At The End (Update the id Respectively)
                ,{
                id: 7,
                service: 'Something Amazing',
                imageSrc: "",
                url: ''
            }
                */
  ],

  // Contact Section
  contactPara:
    "You want to hire me?\nOr simply want to discuss about your amazing project?\nDo not hesitate to get in touch !",
  social: [
    // Add Or Remove The Link Accordingly
    {
      name: "LinkedIn",
      url: "https://www.linkedin.com/in/bartolonibryan/"
    },
    {
      name: "Github",
      url: "https://github.com/zarocksx"
    }
  ],

  // About Page
  aboutTitle: "I will make remarkable digital products",
  aboutPara:"Front end developer since 2017.\n I ❤️ Typescript and vanilla JS.Otherwise I'm a Godot Engine enthusiast."
};